import type { RebrandVersion } from 'lib/theme/paletteVersion'

const DARK_HERO_TIERS = new Set<App.LoyaltyTier>(['platinum', 'infinite'])

export function isLoyaltyDarkHeroTier(tier: App.LoyaltyTier): boolean {
  return DARK_HERO_TIERS.has(tier)
}

/**
 * Primary CTAs on tier-gradient heroes: filled tier colour on light
 * tiers, ghost/dark on platinum and infinite so the button stays readable.
 * The campaign hero stays black in both palettes, so it keeps `variant="ghost"`.
 * Status Match moves to the light sand surface under rebrand and fills instead.
 */
export function getLoyaltyHeroPrimaryButtonVariant(
  tier: App.LoyaltyTier,
  rebrandVersion: RebrandVersion,
): 'default' | 'ghost' | 'dark' {
  if (!isLoyaltyDarkHeroTier(tier)) {
    return 'default'
  }

  return rebrandVersion === 'rebrand' ? 'ghost' : 'dark'
}
